(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portfolio-brand-rows"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', event => {
    const activeRow = event.target;

    if (!activeRow.matches('.portfolio-brand-rows__row') || !activeRow.open) {
      return;
    }

    activeRow.closest('.portfolio-brand-rows__list')
      ?.querySelectorAll('.portfolio-brand-rows__row[open]')
      .forEach(row => {
        if (row !== activeRow) {
          row.open = false;
        }
      });
  }, true);

  } catch(e) { console.error(e); }
})();
})();
